import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AnalyticsService } from '../services/analytics/service.js';
import { iOSCardFix } from '../helpers/ios-cards-fix.js';
let BallerLeague = class BallerLeague extends LitElement {
    constructor() {
        super(...arguments);
        this.environment = 'unknown';
    }
    connectedCallback() {
        super.connectedCallback();
        this.environment = this._getEnvironmentFromHostname(window.location.hostname);
        this._validateThemeUri();
        this.analyticsService = new AnalyticsService({
            debugMode: true,
            environment: this.environment,
            baseUrl: this.themeUri
        });
        this._performSetupTasks();
        this.addEventListener('newsletter-signup-success', this._onNewsletterSignupSuccess);
        this.addEventListener('newsletter-signup-failed', this._onNewsletterSignupFail);
        this.addEventListener('scroll-media-items', (e) => {
            this._onMediaScrollEvent(e);
        });
        this.addEventListener('tickets_submission_error', this._onCompetitionError);
        iOSCardFix();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('newsletter-signup-success', this._onNewsletterSignupSuccess);
        this.removeEventListener('newsletter-signup-failed', this._onNewsletterSignupFail);
        this.removeEventListener('scroll-media-items', (e) => {
            this._onMediaScrollEvent(e);
        });
        this.removeEventListener('tickets_submission_error', this._onCompetitionError);
        this.analyticsService?.shutdown();
    }
    _onCompetitionError() {
        window.ttt?.event('PropTrackAction', {
            PropTrackAction: 'xing_lp_form_error',
            PropActionOrigin: 'xing_lp_ballerleague',
        });
    }
    _onMediaScrollEvent(e) {
        if (e.detail === 'articles') {
            window.ttt?.event('PropTrackAction', {
                PropTrackAction: 'xing_lp_image_slider_article_click',
                PropActionOrigin: 'xing_lp_ballerleague',
            });
        }
        if (e.detail === 'interviews') {
            window.ttt?.event('PropTrackAction', {
                PropTrackAction: 'xing_lp_image_slider_interview_click',
                PropActionOrigin: 'xing_lp_ballerleague',
            });
        }
    }
    _onNewsletterSignupFail() {
        window.ttt?.event('PropTrackAction', {
            PropTrackAction: 'newsletter_lp_form_error',
            PropActionOrigin: 'xing_lp_ballerleague',
        });
    }
    _onNewsletterSignupSuccess() {
        window.ttt?.event('PropTrackAction', {
            PropTrackAction: 'newsletter_lp_signup_click',
            PropActionOrigin: 'xing_lp_ballerleague',
        });
    }
    render() {
        return html `<slot></slot>`;
    }
    _validateThemeUri() {
        if (this.themeUri !== undefined) {
            try {
                const parsedUri = new URL(this.themeUri);
                if (parsedUri.hostname !== window.location.hostname) {
                    throw new Error("theme-uri attribute does not match current hostname");
                }
            }
            catch (error) {
                console.error(error);
                this.themeUri = undefined;
            }
        }
    }
    _performSetupTasks() {
        if (this.environment === 'production' || this.environment === 'staging') {
            this.analyticsService?.init();
        }
    }
    _getEnvironmentFromHostname(hostname) {
        const environments = new Map([
            ["ballerleague.xing.com", "production"],
            ["preview-ballerleague.xing.com", "staging"],
            ["blch.inuit.agency", "staging"],
            ["localhost", "development"]
        ]);
        if (environments.has(hostname)) {
            return environments.get(hostname);
        }
        return "unknown";
    }
};
__decorate([
    property({ type: String })
], BallerLeague.prototype, "environment", void 0);
__decorate([
    property({ type: String, attribute: 'theme-uri' })
], BallerLeague.prototype, "themeUri", void 0);
BallerLeague = __decorate([
    customElement('baller-league')
], BallerLeague);
export { BallerLeague };
//# sourceMappingURL=baller-league.js.map